// extracted by mini-css-extract-plugin
export default {"placeholderEmpty":"placeholderEmpty--PCery"};